import React, { RefObject, forwardRef } from "react";
import { Portal } from "../portal";
import '../../styles/components/headerModal.scss';

//TODO: Заменить на обычную модалку, когда будет подходить работа по отображению встреч и т.д.

/** Выравнивание эл-та относительно родительского
 * Первая буква обозначает край родительского, вторая - край children
 * @example 'l-l' - левая грань дочернего эл-та под левой родительской
 */
type TAlignContentByParent = 'l-l' | 'r-r';

interface HeaderModalProps {
  children: React.ReactNode;
  onClose: () => void;
  alignContent?: TAlignContentByParent;
}

export const HeaderModal = forwardRef<HTMLDivElement, HeaderModalProps>(({ children, alignContent='l-l', onClose }, ref: RefObject<HTMLDivElement>) => {
  const coords = ref.current?.getBoundingClientRect();
  
  let top = coords?.bottom;

  let x = coords?.left;
  alignContent == 'r-r' && (x = window.visualViewport.width - coords?.right);  

  const position = alignContent === 'l-l' ? { left: x, top } : { right: x, top };

  return (
    <Portal where={document.getElementById('modalContainer')}>
      <div
        className="header-modal-wrapper"
        onClick={onClose}
      >
        <div
          className="header-modal-container"
          style={ position }
          onClick={(event) => event.stopPropagation()}
        >
          {children}
        </div>
      </div>
    </Portal>
  )
})